export default "__VITE_ASSET__CYE$PGE3__"